export default {
  UNAUTHORIZED: 'UNAUTHORIZED',
  SESSION_NOT_FOUND: 'SESSION_NOT_FOUND',
  MESSAGE_REJECTED: 'MESSAGE_REJECTED',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  BAD_REQUEST: 'BAD_REQUEST',
  DIALOG_NOT_FOUND: 'DIALOG_NOT_FOUND',
};
